import { SMTP } from "../../class/index";
export default {
    data() {
        return {
            user: null
        };
    },
    methods: {
        loadPonto() {
            if (this.$route.params.id) {
                SMTP.byID(this.$route.params.id)
                    .then(row => this.$store.commit("setSmtp", row))
                    .catch(() => this.$store.commit("setSmtp", SMTP.create()));
            }
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        if (this.$route.params.id) {
            this.loadPonto(this.$route.params.id);
        } else {
            this.$store.commit("setSmtp", SMTP.create());
        }
    }
};
